import { Component, OnInit, Input, ViewChild, Output, EventEmitter, OnChanges, SimpleChanges } from '@angular/core';
import { NestedTreeControl } from '@angular/cdk/tree';
import { MatTreeNestedDataSource } from '@angular/material/tree';
import { ModuloSistema, Modulos } from 'src/app/@shared/models/modulos-sistema.model';
import { PerfilService } from 'src/app/services/perfil/perfil.service';
import { MatSnackBar } from '@angular/material/snack-bar';
import { HttpErrorResponse } from '@angular/common/http';

@Component({
  selector: 'app-arvore-modulos',
  templateUrl: './arvore-modulos.component.html',
  styleUrls: ['./arvore-modulos.component.scss']
})


export class ArvoreModulosComponent
  implements OnChanges, OnInit {

  @ViewChild('tree') tree;
  treeControl = new NestedTreeControl<ModuloSistema>(node => node.children);
  dataSource = new MatTreeNestedDataSource<ModuloSistema>();
  todos_modulos: ModuloSistema[] = [];
  todos_modulos_copy: ModuloSistema[] = [];

  @Input('hasCheckbox') hasCheckbox: boolean = true;
  @Input('perfilId') perfilId: number;
  @Input('isLoading') isLoading = true;
  @Input('modoEdicao') modoEdicao = false;

  @Input('basePadrao') basePadrao: boolean = true;
  @Input('baseRelatorios') baseRelatorios: boolean = true;
  @Input('baseHistorico') baseHistorico: boolean = true;

  @Output() changeLoading = new EventEmitter();


  constructor(
    private perfilService: PerfilService,
    public snackBar: MatSnackBar
  ) {

  }

  ngOnChanges(changes: SimpleChanges) {
    if (!this.isLoading && (changes['modoEdicao']?.currentValue !== changes['modoEdicao']?.previousValue)) {
      this.atualizaDataSource();
    }
  }

  ngOnInit() {
    this.selecionarEstruturaPerfilAcesso();
  }

  loadingEvent() {
    this.changeLoading.emit(this.isLoading);
  }

  selecionarEstruturaPerfilAcesso() {
    this.perfilService.selecionarEstruturaPerfilAcesso(this.perfilId)
      .subscribe(
        (response: ModuloSistema[]) => {
          this.todos_modulos = response;
          this.todos_modulos_copy = JSON.parse(JSON.stringify(this.todos_modulos));
          this.atualizaDataSource();
          this.isLoading = false;
          this.loadingEvent();
        },
        (err: HttpErrorResponse) => {
          console.error(err);
          this.openSnackBar('Ocorreu um erro ao consultar a árvore! Tente novamente ou entre em contato com o suporte : ' + err.error.Protocolo ?? err.error.Message, 'OK', 10000, 'danger-snackbar');
        });
  }

  obterFiltrado(array_modulos: ModuloSistema[]) {
    let _copy = JSON.parse(JSON.stringify(array_modulos));
    return _copy.filter(o => {
      let _keep = true;
      if (o.children?.length > 0) {
        o.children = this.obterFiltrado(o.children);
        _keep = o.children.length > 0;
      } else {
        var filtra_base =
          ((this.basePadrao && o.moduloBaseOrigemId === 1)
            || (this.baseRelatorios && o.moduloBaseOrigemId === 2)
            || (this.baseHistorico && o.moduloBaseOrigemId === 3))
          || (!this.basePadrao && !this.baseRelatorios && !this.baseHistorico);

        _keep = o.permiteAlterarBaseOrigem && filtra_base;
      }

      return _keep;

    })
  }

  atualizaExterno() {
    this.isLoading = true;
    setTimeout(() => {
      this.atualizaDataSource();
      this.isLoading = false;
    }, 500);
  }

  atualizaDataSource() {
    this.dataSource.data = !this.modoEdicao ? this.todos_modulos : this.obterFiltrado(this.todos_modulos_copy);

    let selectParents = node => {
      if (!node) return;
      else if (node.children.every(ch => ch.selected))
        node.selected = true;
      else if (node.children.some(ch => ch.selected || ch.indeterminate))
        node.indeterminate = true;
      selectParents(node.parent);
    };

    let selectChildren = (node) => {
      node.selected = !!node.perfilAcessoId;
      if (node.children && node.children.length)
        node.children.forEach(v => {
          v.parent = node;
          selectChildren(v);
        });
      else selectParents(node.parent);
    };

    this.dataSource.data.forEach(selectChildren);


    Object.keys(this.dataSource.data).forEach(x => {
      this.setParent(this.dataSource.data[x], null);
    });
    this.treeControl.dataNodes = this.dataSource.data;
    this.treeControl.expandAll();
  }

  hasChild = (_: number, node: Modulos) =>
    !!node.children && node.children.length > 0

  setParent(data, parent) {
    data.parent = parent;

    if (data.children) {
      data.children.forEach(x => {
        this.setParent(x, data);
      });
    }
  }

  checkAllParents(node) {
    if (node.parent) {
      const descendants = this.treeControl.getDescendants(node.parent);
  
      if (descendants.length > 1) {
        node.parent.selected = descendants.every(child => child.selected);
        node.parent.indeterminate = descendants.some(child => child.selected || child.indeterminate);
      }
  
      this.checkAllParents(node.parent);
    }
  }
  

  checkItem(checked, node) {
    node.selected = checked;
    if (node.children.length > 0) {
      node.children.forEach(x => {
        this.checkItem(checked, x);
      });
    } else {
      this.checkAllParents(node);
    }
  }

  getCheckedItens(): Array<number> {
    let result = [];

    this.dataSource.data.forEach(node => {
      result = result.concat(
        this.treeControl
          .getDescendants(node)
          .filter(x => x.selected)
          .map(x => x.moduloId)
      );
    });

    return result;
  }

  getCheckedItensEdit(): Array<number> {
    let result = [];

    this.dataSource.data.forEach(node => {
      result = result.concat(
        this.treeControl
          .getDescendants(node)
          .filter(x => x.children?.length === 0 && x.selected)
          .map(x => x.moduloId)
      );
    });

    return result;
  }

  salvarAlteracoes(nova_base) {
    let selected = this.getCheckedItensEdit();
    if (selected?.length > 0 && nova_base) {
      this.isLoading = true;
      this.loadingEvent();
      this.perfilService.alterarBaseOrigem(nova_base, selected)
        .subscribe(
          (response) => {
            if (response.sucesso) {
              this.openSnackBar('Dados alterados com sucesso! Recarregando árvore', 'OK', 5000, 'success-snackbar');
              this.selecionarEstruturaPerfilAcesso();
            } else {
              this.openSnackBar(response.mensagem, 'OK', 5000, 'warning-snackbar');
              this.isLoading = false;
              this.loadingEvent();
            }

          },
          (err: HttpErrorResponse) => {
            console.error(err);
            this.openSnackBar('Ocorreu um erro ao consultar a árvore! Tente novamente ou entre em contato com o suporte : ' + err.error.Protocolo ?? err.error.Message, 'OK', 10000, 'danger-snackbar');
            this.isLoading = false;
            this.loadingEvent();
          });
    } else {
      this.openSnackBar('Selecione itens na árvore e a nova base! Tente novamente', 'OK', 3000, 'warning-snackbar');
    }
  }

  expandAll() {
    this.treeControl.expandAll();
  }

  collapseAll() {
    this.treeControl.collapseAll();
  }

  openSnackBar(message: string, action: string, duration: number, panelClass?: string): any {
    this.snackBar.open(message, action, { duration, panelClass });
  }

}
